// import { Link } from "react-router-dom";
// import { Facebook, Instagram, Twitter, Linkedin } from "lucide-react";
// import "./Footer.css";

// export default function Footer() {
//   return (
//     <footer className="footer">
//       <div className="footer-container">


//         <div>
//           <div className="footer-grid">


//             <div className="footer-left">
//               <div className="footer-brand">
//                 <h2>Solvra</h2>
//                 <p>
//                   Powering homes and businesses with smart, sustainable solar
//                   energy solutions for a greener future.
//                 </p>
//               </div>

//               <div className="footer-links social-section">
//                 <h4>Follow Us</h4>
//                 <div className="footer-social">
//                   <a href="#" aria-label="Facebook">
//                     <Facebook size={18} />
//                   </a>
//                   <a href="https://www.instagram.com/lumaxsunlightenergy?utm_source=qr&igsh=MWRmbDJldHIycGNyeA==" target="bln" aria-label="Instagram">
//                     <Instagram size={18} />
//                   </a>
//                   <a href="#" aria-label="Twitter">
//                     <Twitter size={18} />
//                   </a>
//                   <a href="#" aria-label="LinkedIn">
//                     <Linkedin size={18} />
//                   </a>
//                 </div>
//               </div>
//             </div>


//             <div className="footer-right footer-links">
//               <h4>Quick Links</h4>

//               <div className="footer-links-grid">
//                 <ul>
//                   <li><Link to="/">Home</Link></li>
//                   <li><Link to="/solutions">Solutions</Link></li>
//                   <li><Link to="/service">Service</Link></li>
//                   <li><Link to="/i-c">I & C</Link></li>
//                 </ul>

//                 <ul>
//                   <li><Link to="/about">About</Link></li>
//                   <li><Link to="/contact">Contact</Link></li>
//                   <li><Link to="/gallery">Gallery</Link></li>
                  
//                 </ul>
//               </div>
//             </div>


//           </div>
//         </div>

//         {/* Bottom */}
//         <div className="footer-bottom">
//           © {new Date().getFullYear()} Solvra. All rights reserved.
//         </div>

//       </div>
//     </footer>
//   );
// }



import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter, Linkedin, Mail } from "lucide-react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-card">
          <div className="footer-grid">

            {/* LEFT */}
            <div className="footer-left">
              <div className="footer-brand">
                <h2>Solar</h2>
                <span className="brand-line" />
                <p>
                  Powering homes and businesses with smart, sustainable solar
                  energy solutions for a greener future.
                </p>
              </div>

              {/* Newsletter */}
              {/* <div className="footer-newsletter">
                <h4>Stay Updated</h4>
                <div className="newsletter-box">
                  <Mail size={18} />
                  <input type="email" placeholder="Enter your email" />
                  <button>Subscribe</button>
                </div>
              </div> */}

              {/* Social */}
              <div className="footer-links social-section">
                <h4>Follow Us</h4>
                <div className="footer-social">
                  <a href="#"><Facebook size={18} /></a>
                  <a href="https://www.instagram.com/lumaxsunlightenergy" target="_blank">
                    <Instagram size={18} />
                  </a>
                  <a href="#"><Twitter size={18} /></a>
                  <a href="#"><Linkedin size={18} /></a>
                </div>
              </div>
            </div>
            

            {/* RIGHT */}
            <div className="footer-right footer-links">
              <h4 style={{textAlign: "center" , margin: "20px 0 0 0"}}>Quick Links</h4>
              <div className="footer-links-grid">
                <ul></ul>
                <ul>
                  <li><Link to="/" >Home</Link></li>
                  <li><Link to="/i-c">I & C</Link></li>
                  <li><Link to="/solutions">Solutions</Link></li>
                  <li><Link to="/pricing">Service</Link></li>
                </ul>
                <ul>
                  <li><Link to="/about">About</Link></li>
                  <li><Link to="/contact">Contact</Link></li>
                  <li><Link to="/gallery">Gallery</Link></li>
                </ul>
              </div>
            </div>

          </div>
        </div>
       

        {/* Bottom */}
        <div className="footer-bottom">
          <marquee behavior="scroll" direction="left" scrollamount="5" className="footer-bottom-text">
          © {new Date().getFullYear()} Solar. All rights reserved.
          </marquee>
        </div>

      </div>
    </footer>
  );
}

